import React, { useEffect, useState } from "react";
import footerLogo from "../../../../assets/images/ads/footer_logo.png";
import fbIcon from "../../../../assets/images/ads/fb_icon.svg";
import instaIcon from "../../../../assets/images/ads/insta_icon.svg";
import linkedInIcon from "../../../../assets/images/ads/linked_in.svg";
import youtubeIcon from "../../../../assets/images/ads/youtube_icon.svg";
import whatsappIcon from "../../../../assets/images/ads/whatsapp_icon_.svg";
import Toast from "../Common/Toast/Toast";
import Loader from "../Common/Loader/Loader";
import { data } from "../Constant/data";
import { NavLink } from "react-router-dom";
let footerData = data.footer;

const Footer = () => {
  const [notification, setNotification] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    name: "",
    email: "",
    feedback: "",
  });

  const notificationTimeout = React.useRef(null);

  const isValidTextArea = (text) =>
    text && text.length >= 3 && text.length <= 300;

  const isValidName = (name) => name && name.trim().length > 2;

  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email.trim());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess(false);

    const { name, email, feedback } = data;

    if (!isValidName(name)) {
      setNotification("Please enter a valid name.");
      return;
    }

    if (!isValidEmail(email)) {
      setNotification("Enter a valid email.");
      return;
    }

    if (!isValidTextArea(feedback)) {
      setNotification("Enter a valid feedback.");
      return;
    }

    const requestData = {
      name,
      email,
      message: feedback,
      subject: `Messages Form ${new Date().getTime()}`,
      formType: "messagesForm",
      site: "lumi",
    };

    setLoading(true);
    try {
      const response = await fetch(
        "https://lumimatrimony.com/api/ads/write-to-us",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to submit. Please try again later.");
      }

      setSuccess(true);
      setNotification("Your request was successfully submitted.");
      handleReset();
    } catch (error) {
      setNotification(error.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setData({ name: "", email: "", feedback: "" });
  };

  const updateData = (e) => {
    setData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  useEffect(() => {
    if (notification) {
      clearTimeout(notificationTimeout.current);
      notificationTimeout.current = setTimeout(() => setNotification(""), 3000);
    }
    return () => clearTimeout(notificationTimeout.current);
  }, [notification]);

  return (
    <>
      <footer className="bg_darkgray">
        <div className="container flex_box">
          <div className="left">
            <h2 className="text_md2 text_white fw_light mb">Write To Us</h2>
            <form id="lumi-write-to-us-form" onSubmit={handleSubmit}>
              <div>
                <div className="input_field_cnt col_5">
                  <input
                    type="text"
                    id="write-to-us-name"
                    placeholder="Name"
                    name="name"
                    maxLength="30"
                    value={data.name}
                    onChange={updateData}
                    className="text_capitalize"
                  />
                </div>
                <div className="input_field_cnt col_5">
                  <input
                    type="email"
                    id="write-to-us-email"
                    placeholder="Email"
                    name="email"
                    maxLength="50"
                    value={data.email}
                    onChange={updateData}
                  />
                </div>
                <div className="input_field_cnt col_full">
                  <textarea
                    id="write-to-us-body"
                    placeholder="Feedback"
                    name="feedback"
                    maxLength="300"
                    value={data.feedback}
                    onChange={updateData}
                  ></textarea>
                </div>
              </div>
              <div className="input_field_cnt">
                <button
                  id="submit-form-button"
                  className="btn primary"
                  type="submit"
                >
                  Send
                </button>
              </div>
              {loading && (
                <div className="text_center loader_wrap">
                  <Loader />
                </div>
              )}
            </form>
          </div>

          <div className="middle">
            <ul className="footer_nav">
              {
                footerData?.navLinks?.map((el, index) => {
                  return (
                    <li key={index}>
                      <NavLink to={el.href} className="text_md2">{el.label}</NavLink>
                    </li>
                  )
                })
              }
            </ul>
            <ul className="social_wrap desktop_visibility">
              <li>
                <a href="https://lumimatrimony.com/facebook/">
                  <img src={fbIcon} className="icon" alt="Facebook" />
                </a>
              </li>
              <li>
                <a href="https://lumimatrimony.com/instagram/">
                  <img src={instaIcon} className="icon" alt="Instagram" />
                </a>
              </li>
              <li>
                <a href="https://lumimatrimony.com/linkedin">
                  <img src={linkedInIcon} className="icon" alt="LinkedIn" />
                </a>
              </li>
              <li>
                <a href="https://lumimatrimony.com/youtube/">
                  <img src={youtubeIcon} className="icon" alt="YouTube" />
                </a>
              </li>
              <li>
                <a href="https://lumimatrimony.com/whatsapp/">
                  <img src={whatsappIcon} className="icon" alt="WhatsApp" />
                </a>
              </li>
            </ul>
          </div>

          <div className="right">
            <a href="#" className="footer_logo">
              <img
                src={footerLogo}
                alt="Footer Logo"
                className="desktop_visible icon"
              />
            </a>
          </div>
        </div>
        <div className="copyright text_center text_white">
          <span className="text_sm">
            Copyright &copy; 2025 FlipTree Technologies (India) Private Limited.<br></br>
            All Rights Reserved. <a href={footerData?.privacy?.href} className="text_white fw_light">{footerData?.privacy?.title}</a> & {' '}
            <a href={footerData?.terms?.href} className="text_white fw_light">{footerData?.terms?.title}</a>
          </span>
        </div>
      </footer>
      {notification && (
        <Toast
          message={notification}
          time="2000"
          className={success ? "active" : ""}
          success={success}
          aria-live="polite"
        />
      )}
    </>
  );
};

export default Footer;
